var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatAct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "21px",
    viewBox: "0 0 24 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico-chat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "C\\xEDrculo-del-Paciente",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(-46.000000, -365.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(0.000000, 103.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-chat",
    transform: "translate(16.000000, 39.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.000000, 223.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3529412,11.3418147 L19.3529412,2.27844455 C19.3529412,1.02328373 18.3578431,0 17.1372549,0 L2.21568627,0 C0.995098039,0 0,1.02328373 0,2.27844455 L0,11.3418147 C0,12.5969755 0.995098039,13.6202592 2.21568627,13.6202592 L2.84803922,13.6202592 L2.84803922,16.3523764 C2.84803922,16.856457 3.24509804,17.2647624 3.74019608,17.2647624 L3.74019608,17.2647624 C3.99509804,17.2647624 4.24019608,17.1488238 4.41176471,16.9471916 L7.21078431,13.6152184 L17.1421569,13.6152184 C18.3578431,13.6202592 19.3529412,12.5969755 19.3529412,11.3418147 Z M6.93137255,12.3852616 C6.75490196,12.3852616 6.59313725,12.4608737 6.4754902,12.5969755 L4.04411765,15.4853577 L4.04411765,13.00024 C4.04411765,12.6574652 3.7745098,12.3802208 3.44117647,12.3802208 L2.21568627,12.3802208 C1.65686275,12.3802208 1.20098039,11.9114258 1.20098039,11.3367739 L1.20098039,2.27844455 C1.20098039,1.70379261 1.65686275,1.2349976 2.21568627,1.2349976 L17.1372549,1.2349976 C17.6960784,1.2349976 18.1519608,1.70379261 18.1519608,2.27844455 L18.1519608,11.3418147 C18.1519608,11.9164666 17.6960784,12.3852616 17.1372549,12.3852616 L6.93137255,12.3852616 L6.93137255,12.3852616 Z",
    id: "Shape",
    fill: "#0063A6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5931373,20.6824292 C19.7647059,20.8891023 20.0098039,21 20.2598039,21 C20.3627451,21 20.4705882,20.9798368 20.5735294,20.9395103 C20.9264706,20.8034085 21.1519608,20.4707153 21.1519608,20.0825732 L21.1519608,17.3504561 L21.7843137,17.3504561 C23.004902,17.3504561 24,16.3271723 24,15.0720115 L24,6.00864138 C24,4.75348056 23.004902,3.73019683 21.7843137,3.73019683 C21.4509804,3.73019683 21.1813725,4.00744119 21.1813725,4.34517523 C21.1813725,4.68795007 21.4509804,4.96519443 21.7843137,4.96519443 C22.3431373,4.96519443 22.7990196,5.43398944 22.7990196,6.00864138 L22.7990196,15.0720115 C22.7990196,15.6466635 22.3431373,16.1154585 21.7843137,16.1154585 L20.5539216,16.1154585 C20.2205882,16.1154585 19.9509804,16.3927028 19.9509804,16.7354777 L19.9509804,19.2205953 L17.5196078,16.3322132 C17.4068627,16.1961114 17.2401961,16.1204993 17.0637255,16.1204993 L8.04411765,16.1204993 C7.71078431,16.1204993 7.44117647,16.3977436 7.44117647,16.7405185 C7.44117647,17.0832933 7.71078431,17.3605377 8.04411765,17.3605377 L16.7892157,17.3605377 L19.5931373,20.6824292 Z",
    id: "Path",
    fill: "#0063A6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#0063A6",
    fillRule: "nonzero",
    cx: 9.67647059,
    cy: 7.0268843,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#0063A6",
    fillRule: "nonzero",
    cx: 12.0735294,
    cy: 7.0268843,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#0063A6",
    fillRule: "nonzero",
    cx: 7.27941176,
    cy: 7.0268843,
    rx: 1,
    ry: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatAct);
export default __webpack_public_path__ + "static/media/chat-act.51fe8397e3ff94c47af74390e43349d5.svg";
export { ForwardRef as ReactComponent };